// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn--3MWh4","editable":"editable--30WMe"};